import type { ReplaceTestIdWithAppOne } from '../../const/testIds';

import { AppBaseTooltip, type AppBaseTooltipProps } from './AppBaseTooltip';

export type AppTooltipProps = ReplaceTestIdWithAppOne<AppBaseTooltipProps>;

export const AppTooltip = (props: AppTooltipProps) => (
	<AppBaseTooltip {...props} />
);
